import * as React from "react";
import styled from "styled-components";
import { COLOURS } from "../../../consts/style";
import { LiveHelp } from "../../Svg/LiveHelp";

const ContactUsContainer = styled.div`
  display: flex;
  margin-top: 32px;
  flex-direction: column;
  padding: 16px;
`;

const ContactUsHeading3 = styled.h3`
  line-height: 28px;
  font-size: 20px;
  color: ${COLOURS.TEXT.HEADING};
  font-weight: 600;
  margin: 0px 0px 24px;
`;

const ContactUsText = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: ${COLOURS.TEXT.BODY};
  margin: 0px 0px 2px;
`;

const HelpAndSupportContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  a {
    font-size: 16px;
    line-height: 28px;
    color: ${COLOURS.TEXT.HEADING};
    font-weight: 600;
    text-decoration: none;
  }
  svg {
    margin-right: 4px;
    height: 26px;
    width: 26px;
    fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
  }
`;

export const MobileMenuContactUs = () => (
  <ContactUsContainer>
    <ContactUsHeading3>Need some help?</ContactUsHeading3>
    <ContactUsText>
      Find contact details, answers to questions, and handy how-tos at our help
      and support centre.
    </ContactUsText>

    <HelpAndSupportContainer>
      <LiveHelp /> <a href="/help-support">View help and support</a>
    </HelpAndSupportContainer>
  </ContactUsContainer>
);
